var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.1 3.00273C1.70751 3.00273 2.2 2.51025 2.2 1.90273C2.2 1.29522 1.70751 0.802734 1.1 0.802734C0.492487 0.802734 0 1.29522 0 1.90273C0 2.51025 0.492487 3.00273 1.1 3.00273ZM1.1 7.40117C1.70751 7.40117 2.2 6.90869 2.2 6.30117C2.2 5.69366 1.70751 5.20117 1.1 5.20117C0.492487 5.20117 0 5.69366 0 6.30117C0 6.90869 0.492487 7.40117 1.1 7.40117ZM2.2 10.6996C2.2 11.3071 1.70751 11.7996 1.1 11.7996C0.492487 11.7996 0 11.3071 0 10.6996C0 10.0921 0.492487 9.59961 1.1 9.59961C1.70751 9.59961 2.2 10.0921 2.2 10.6996ZM4.61563 0.802734C4.00811 0.802734 3.51562 1.29522 3.51562 1.90273C3.51562 2.51025 4.00811 3.00273 4.61563 3.00273H12.9756C13.5831 3.00273 14.0756 2.51025 14.0756 1.90273C14.0756 1.29522 13.5831 0.802734 12.9756 0.802734H4.61563ZM3.51562 6.30117C3.51562 5.69366 4.00811 5.20117 4.61563 5.20117H12.9756C13.5831 5.20117 14.0756 5.69366 14.0756 6.30117C14.0756 6.90869 13.5831 7.40117 12.9756 7.40117H4.61563C4.00811 7.40117 3.51562 6.90869 3.51562 6.30117ZM4.61563 9.59961C4.00811 9.59961 3.51562 10.0921 3.51562 10.6996C3.51562 11.3071 4.00811 11.7996 4.61563 11.7996H12.9756C13.5831 11.7996 14.0756 11.3071 14.0756 10.6996C14.0756 10.0921 13.5831 9.59961 12.9756 9.59961H4.61563Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.ce1b89e8b859b8d45f1b0d5c72457000.svg";
export { ForwardRef as ReactComponent };